var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"is-open":_vm.isOpen,"is-loading":_vm.loading,"disabled":_vm.loading,"title":"Удалить все изделия из заказа?","btn-save-title":"Удалить"},on:{"onCloseModal":_vm.closeModal,"onSaveModal":_vm.confirmModal}})}
var staticRenderFns = []

export { render, staticRenderFns }